__turbopack_context__.v({
  "accorion-item-button": "accordion-module-scss-module__2UBRTG__accorion-item-button",
  "accorion-item-content": "accordion-module-scss-module__2UBRTG__accorion-item-content",
  "accorion-item-text": "accordion-module-scss-module__2UBRTG__accorion-item-text",
  "open": "accordion-module-scss-module__2UBRTG__open",
});
